module.exports = __webpack_public_path__ + "img/banner2.edc6d756.png";